import { useState, useEffect } from 'react';

export function AppHeader({ userProfile, currentUser, onLogout, windowWidth }) {
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Get user initials from display name
  const getUserInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name[0].toUpperCase();
  };

  // Listen for sidebar close events to sync state
  useEffect(() => {
    const handleToggle = (e) => {
      setMobileMenuOpen(e.detail.open);
    };

    window.addEventListener('toggleMobileMenu', handleToggle);
    return () => window.removeEventListener('toggleMobileMenu', handleToggle);
  }, []);

  // Close user dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userDropdownOpen && !event.target.closest('.user-dropdown-container')) {
        setUserDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [userDropdownOpen]);

  const toggleMobileMenu = () => {
    const newState = !mobileMenuOpen;
    setMobileMenuOpen(newState);
    // Trigger event for Sidebar to listen to
    window.dispatchEvent(new CustomEvent('toggleMobileMenu', { detail: { open: newState } }));
  };

  return (
    <header className="app-header">
      {windowWidth < 768 && (
        <button className="menu-toggle" onClick={toggleMobileMenu}>
          <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>
      )}

      <div className="header-brand">
        <h1>QualiMed Swiss</h1>
      </div>

      <div className="header-right">
        {/* User Avatar Dropdown */}
        <div className="user-dropdown-container">
          <button
            className="user-avatar"
            onClick={(e) => {
              e.stopPropagation();
              setUserDropdownOpen(!userDropdownOpen);
            }}
            aria-label="User menu"
          >
            {getUserInitials(userProfile.displayName)}
          </button>

          {userDropdownOpen && (
            <div className="user-dropdown">
              <div className="user-dropdown-header">
                <div className="user-dropdown-name">{userProfile.displayName}</div>
                <div className="user-dropdown-email">{currentUser?.email}</div>
              </div>
              <div className="user-dropdown-divider"></div>
              <button className="user-dropdown-item" onClick={onLogout}>
                <i className="fas fa-sign-out-alt"></i>
                <span>Abmelden</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
